const meta = {
  'review-aggregation-rules': 'Review rules',
  'shaping-impact': 'Preview rules',
  recommendations: 'Recommendations',
};

export default meta;
